export var QuestionnaireEnum;
(function (QuestionnaireEnum) {
    QuestionnaireEnum["YES_NO_VALUE"] = "YES_NO_VALUE";
    QuestionnaireEnum["RANGE_VALUE"] = "RANGE_VALUE";
    QuestionnaireEnum["OPEN_QUESTION"] = "OPEN_QUESTION";
    QuestionnaireEnum["CURRENCY_QUESTION"] = "CURRENCY_QUESTION";
    QuestionnaireEnum["DATE_QUESTION"] = "DATE_QUESTION";
    QuestionnaireEnum["ADD_ATTACHMENT"] = "ADD_ATTACHMENT";
    QuestionnaireEnum["CHOICE_SELECTION"] = "CHOICE_SELECTION";
})(QuestionnaireEnum || (QuestionnaireEnum = {}));
export var QuestionnaireOnBlurEnum;
(function (QuestionnaireOnBlurEnum) {
    QuestionnaireOnBlurEnum["OPEN_QUESTION_ON_BLUR"] = "OPEN_QUESTION_ON_BLUR";
    QuestionnaireOnBlurEnum["RANGE_VALUE_ON_BLUR"] = "RANGE_VALUE_ON_BLUR";
    QuestionnaireOnBlurEnum["DATE_QUESTION_ON_BLUR"] = "DATE_QUESTION_ON_BLUR";
    QuestionnaireOnBlurEnum["CURRENCY_QUESTION_ON_BLUR"] = "CURRENCY_QUESTION_ON_BLUR";
})(QuestionnaireOnBlurEnum || (QuestionnaireOnBlurEnum = {}));
//# sourceMappingURL=QuestionnaireEnum.js.map